function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-74 -253)"
}, React.createElement("circle", {
  cx: 18.585,
  cy: 18.585,
  r: 18.585,
  transform: "translate(74 253)",
  fill: "#f60"
}), React.createElement("path", {
  d: "M2391.947-462.162c-.032.032-.065.062-.1.093a12.987,12.987,0,0,1-8.936,3.546,12.991,12.991,0,0,1-8.938-3.546c-.032-.03-.066-.061-.1-.093.141-.357.815-1.654,3.33-2.42,2.938-.893,3.107-1.83,3.107-1.83s.13-1.617.13-2.384a4.017,4.017,0,0,1-1.151-2.6c-.341.043-.426.129-.855-.937s.428-1.362.428-1.362a20.583,20.583,0,0,1-.426-3.149c-.126-3.489,2.852-4.129,4.471-4.129s4.6.639,4.469,4.129a20.583,20.583,0,0,1-.426,3.149s.858.3.428,1.362-.513.979-.854.937a4.013,4.013,0,0,1-1.152,2.6c0,.767.13,2.384.13,2.384s.171.937,3.107,1.83C2391.134-463.815,2391.807-462.518,2391.947-462.162Z",
  transform: "translate(-2289.855 741.182)",
  fill: "#f5f7f8"
}));

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 37.171,
    height: 37.171,
    viewBox: "0 0 37.171 37.171",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar.3196229e.svg";
export { ForwardRef as ReactComponent };